var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C2.90927 0 0 2.90927 0 6.5C0 10.0907 2.90927 13 6.5 13C10.0907 13 13 10.0907 13 6.5C13 2.90927 10.0907 0 6.5 0ZM10.2742 7.23387C10.2742 7.40685 10.1327 7.54839 9.95968 7.54839H7.54839V9.95968C7.54839 10.1327 7.40685 10.2742 7.23387 10.2742H5.76613C5.59314 10.2742 5.45161 10.1327 5.45161 9.95968V7.54839H3.04032C2.86734 7.54839 2.72581 7.40685 2.72581 7.23387V5.76613C2.72581 5.59314 2.86734 5.45161 3.04032 5.45161H5.45161V3.04032C5.45161 2.86734 5.59314 2.72581 5.76613 2.72581H7.23387C7.40685 2.72581 7.54839 2.86734 7.54839 3.04032V5.45161H9.95968C10.1327 5.45161 10.2742 5.59314 10.2742 5.76613V7.23387Z",
    fill: "#21FCA2",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGreen);
export default __webpack_public_path__ + "static/media/plusGreen.d05842b34319b66b1b5e0dcb3aa2a611.svg";
export { ForwardRef as ReactComponent };